<template>
  <div class="video-graph">
    <div v-show="!videoFlag" class="video-graph-content">
      <img class="coverMobile" :src="courseBaseData.coverMobile"/>
      <img @click="clickVideoPlayer" class="icon_audition"
           src="../../../assets/img/components/courseDetail/icon_audition_big.png" alt=""/>
    </div>

    <div v-show="videoFlag">
      <swiper id="mySwiper" ref="mySwiper" @slideChange="slideChange" class="swiper" :options="swiperOption">
        <swiper-slide :key="index" v-for="(item,index) in courseBaseData.productCoverVideoRespVOS">
          <div class="video-player" style="position: relative">
            <div :id="nameId(item,index)" class="video-graph-video">{{ index }}</div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>
<script>
import loadJS from 'load-js';
import { mapState } from 'vuex';
import { RECORD_SITE_ID } from '@/utils/common';
import { gioPlatform, judgmentPlatform } from '@/utils/tools';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
// eslint-disable-next-line import/no-extraneous-dependencies
import {reqClassNameType} from '@/api/courseDetail';
import 'swiper/dist/css/swiper.css';

export default {
  name: 'videoGraphs',
  computed: {
    ...mapState(['courseBaseData', 'buyStatus', 'productSku', 'containCurriculumData']),
  },
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    const that = this;
    return {
      videoFlag: false,
      player: null,
      currentIndex: 0,
      pageWidth: document.body.offsetWidth, // 页面宽度
      swiperOption: {
        pagination: {
          el: '.swiper-pagination', // 与slot="pagination"处 class 一致
          clickable: true, // 轮播按钮支持点击
          bulletClass: 'my-bullet',
          bulletActiveClass: 'my-bullet-active',
          renderBullet(index, className) {
            return `<span class="${className}">${that.courseBaseData.productCoverVideoRespVOS[index].name}</span>`;
          },
        },
      },
    };
  },
  beforeCreate() {
    loadJS([
      {
        async: false,
        url: 'https://p.bokecc.com/player?siteid=096E928BC2A97B87&newversion=true',
      },
    ]);
  },
  mounted() {},
  methods: {
    slideChange() {
      this.player.destroy();
      const count = this.$refs.mySwiper.swiper.activeIndex;
      if (count === this.currentIndex) return;
      this.currentIndex = count;
      this.setPlayerCallBack();
    },
    nameId(item, index) {
      return `videoPlayer${index}`;
    },
    // 处理进度条拖动问题
    handleProgress() {
      const dom = document.getElementsByClassName('ccH5DragBtn')[0];
      dom.addEventListener(
        'touchstart',
        () => {
          document.getElementById('mySwiper').classList.add('swiper-no-swiping');
        },
        { passive: false },
      );
      dom.addEventListener(
        'touchend',
        () => {
          document.getElementById('mySwiper').classList.remove('swiper-no-swiping');
        },
        { passive: false },
      );
    },
    // 切换播放视频
    changeVideo(index, type) {
      let INDEX;
      if (type === 'click') {
        INDEX = index;
      } else {
        INDEX = this.currentIndex + 1;
      }
      this.currentIndex = INDEX;
      this.playerVideo(INDEX);
    },
    playerVideo(index) {
      this.$refs.mySwiper.swiper.slideTo(index);
      this.setPlayerCallBack();
    },
    // 点击封面图播放按钮
    clickVideoPlayer() {
      this.videoFlag = true;
      this.init();
    },
    async init() {
      this.setPlayerCallBack();
    },
    // 重新播放
    play() {
      this.player.play();
    },
    createPlayer() {
      if (this.courseBaseData.productCoverVideoRespVOS[this.currentIndex].vid) {
        this.playerEle = document.getElementById(`videoPlayer${this.currentIndex}`);
        const verfitionCode = {
          type: 1,
          videoId: this.courseBaseData.productCoverVideoRespVOS[this.currentIndex].videoId,
        };
        this.player = window.createCCH5Player({
          vid: this.courseBaseData.productCoverVideoRespVOS[this.currentIndex].vid,
          siteid: RECORD_SITE_ID,
          autoStart: true,
          playtype: 1, // H5播放器
          width: '100%',
          height: '100%',
          open_barrage: false,
          useX5Play: true,
          parentNode: this.playerEle,
          closeHistoryTime: 1, // 记忆功能
          isShare: false, // TODO：隐藏分享按钮，目前现在不生效，用CSS强制隐藏了
          vc: JSON.stringify(verfitionCode),
        });
        this.gioEvents(this.courseBaseData.productCoverVideoRespVOS[this.currentIndex].vid, this.courseBaseData.productCoverVideoRespVOS[this.currentIndex].name);
      } else {
        this.$toast('视频地址出错,请刷新后重试～');
      }
    },

    setPlayerCallBack() {
      if (window.createCCH5Player) {
        this.createPlayer();
      } else {
        window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded;
      }
      window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded;
      window.on_CCH5player_ready = this.onPlayerReady;
      window.on_player_volumechange = this.onPlayerVolumeChange;
      window.on_CCH5player_ended = this.onPlayerEnded;
      window.on_CCH5player_play = this.onPlayerPlay;
      window.on_CCH5player_pause = this.onPlayerPause;
      // window.get_cc_verification_code = this.get_cc_verification_code;
    },

    onCCH5PlayerLoaded() {
      window.ccH5PlayerJsLoaded = true;
      this.createPlayer();
    },

    onPlayerReady(obj) {
      const that = this;
      obj?.videoElement.setAttribute('webkit-playsinline', 'true');
      obj?.videoElement.setAttribute('playsinline', 'true');
      this.loading = false;
      window.cc_js_Player.setVolume(0.3);
      setTimeout(() => {
        if (judgmentPlatform() !== 'ios') {
          that.play();
        }
      }, 1000);
    },
    // 播放结束时回调
    onPlayerEnded() {
      // 判断后面有没有视频，有的话，切换下一个，没有的话，展示封面
      if (this.courseBaseData.productCoverVideoRespVOS[this.currentIndex + 1]) {
        this.changeVideo(this.currentIndex + 1, 'auto');
      } else {
        this.currentIndex = 0;
        this.videoFlag = false;
        this.player.destroy();
        this.$refs.mySwiper.swiper.slideTo(0);
      }
      // const btn = document.getElementById(`videoBtn${this.currentIndex + 1}`);
      // const config = {
      //   block: 'nearest', // Y 轴中间位置 - nearest/start/center/end
      //   behavior: 'smooth', // 平滑滚动 - auto/smooth
      //   inline: 'center', // X 轴中间位置 - nearest/start/center/end
      // };
      // btn.scrollIntoView(config);
    },
    // 播放时回调
    onPlayerPlay() {
      this.handleProgress();
    },
    // 暂停播放是回调
    onPlayerPause() {
      // 回调
    },
    onPlayerVolumeChange() {
      // console.log('设置音量回调:  ', volume, vid);
    },
    playDestroy() {
      // eslint-disable-next-line no-unused-expressions
      this.player && this.player.destroy();
    },
   async gioEvents(vid, name) {
      // eslint-disable-next-line no-undef
      let {data} = await reqClassNameType(this.courseBaseData.productId);
      gio('track', 'listenCourse_event', {
        videoID_var: vid,
        videoName_var: name,
        videoType_var: '录播',
        isAudition_var: '是',
        courseId_var: this.courseBaseData.productId.toString(),
        courseName_var: this.courseBaseData.name,
        classSize_var: data.className,
        platform_var: gioPlatform(),
        enter_var: '产品封面',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-pagination-bullet-custom{
  width: 100%;
  height: 50px;
}
.video-graph {
  position: relative;
  width: 100%;
  // margin-bottom: 22px;
  // 因为白边注释

  .video-player {
    position: relative;

    .video-graph-video,
    #playbackPlayer {
      display: flex;
      align-items: center;
      height: calc(100vw * (9 / 16));
      background: black;
    }
  }

  .video-graph-content {
    position: relative;
    width: 100%;

    .coverMobile {
      display: block;
      width: 100%;
      height: 543px;
    }

    .icon_audition {
      position: absolute;
      top: 46%;
      left: 50%;
      width: 127px;
      transform: translate(-50%, -50%);
    }
  }

  .video-list {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 116px;
    padding-left: 36px;
    display: -webkit-box;
    overflow-x: scroll;
    box-sizing: border-box;
    white-space: nowrap;
    font-size: 28px;
    background: #fff;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
    }

    span {
      display: block;
      height: 58px;
      background: #F7F8FC;
      border-radius: 11px;
      padding: 11px 22px;
      margin-right: 22px;
      font-size: 25px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-top: 29px;
      line-height: 36px;
    }

    span.active {
      color: #fff;
      background: #FF7F41;
    }
  }
}
</style>

<style lang="scss">
.swiper-container{
  min-height: calc(100vw * 0.562 + 72px);
}
.swiper-pagination {
  height: 37PX;
  bottom: 0 !important;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  background-color:#222222;
}

.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 43px;
}

.swiper-pagination .my-bullet {
  display: inline-block;
  width: 100%;
  height: 100%;
  cursor: pointer;
  flex: 1;
  font-size: 25px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 72px;
  outline: none;
  -webkit-tap-highlight-color:rgba(0,0,0,0);
  position: relative;
}

.swiper-pagination .my-bullet-active {
  color: #FF7F41;
  border-bottom: 2px solid #FF7F41;
  outline: none;
  -webkit-tap-highlight-color:rgba(0,0,0,0);
}
.swiper-pagination .my-bullet-active::before {
  width: 14px;
  height: 14px;
  display: inline;
  vertical-align: sub;
  margin-right: 4px;
  -webkit-tap-highlight-color:rgba(0,0,0,0);
  content:url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/lQHPJwCC0MmBNvoUFLArlETdxH03fQRwTakegGgA_20_20.gif);
}
.swiper-pagination .my-bullet::after {
  content: "";
  width: 2px;
  height: 20px;
  background: #e3e3e3;
  position: absolute;
  top: 28px;
  right: -2px;
}
.swiper-button-prev, .swiper-button-next {
  position: absolute;
  top: 57%;
  width: 27px;
  height: 25px;
  margin-top: -22px;
  z-index: 10;
  cursor: pointer;
  background-size: 27px 44px;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
